import useFetchFromBackend from "../../shared/lib/fetch-from-backed";

export default function usePoolMembers(queryParams = {}) {
  const { poolId } = queryParams;

  const { data, isLoading, error } = useFetchFromBackend({
    path: `/pool-members/${poolId}`,
    params: queryParams,
    queryKey: ["poollist", queryParams],
    options: {
      staleTime: 60000,
      refetchOnWindowFocus: false,
    },
  });
  return { poolMembers: data, isPoolListLoading: isLoading, error };
}
